import { baseUrl } from './urls'

export const BroadcastMessageType = {
  AuthSuccess: 'auth:success',
  AuthCredentials: 'auth:credentials',
  FrameClose: 'frame:close',
  FrameResize: 'frame:resize',
  TimerStarted: 'timer:started',
  TimerStopped: 'timer:stopped',
}

export function broadcastMessage({
  type,
  value = undefined,
  crossOrigin = false,
  source = window.parent,
  targetOrigin = '*',
}) {
  const message = {
    type: type,
    value: value,
  }

  if (crossOrigin) {
    // We have to be EXTREMELY careful what data we post when the targetOrigin is *
    // According to the docs this is discouraged but
    // it is the only way we can highlight the button or close the popup
    //
    // More info: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
    source.postMessage(message, targetOrigin)
  } else {
    source.postMessage(message, baseUrl)
  }
}

export function broadcastMessageFrameClose() {
  broadcastMessage({
    type: BroadcastMessageType.FrameClose,
    crossOrigin: true,
  })
}
